import React from "react";
import "./style.css";

export default function PageHead({
  title,
  containerStyles = {},
  containerClasses = "",
  leftText,
  rightText
}) {
  return (
    <div
      className={`heading-container ${containerClasses}`}
      style={containerStyles}
    >
      {title && <h3>{title}</h3>}
      {leftText && rightText && (
        <div
          className="d-flex justify-content-between page-head-response-text"
        >
          <h3>{leftText}</h3>
          <h3>{rightText}</h3>
        </div>
      )}
    </div>
  );
}
